import React, { forwardRef, ReactNode } from 'react';
import {
  ListItem as ChakraListItem,
  ListItemProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends ListItemProps {
  children: ReactNode;
}

export const ListItem = forwardRef<HTMLLIElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`ListItem`);

    return (
      <ChakraListItem ref={ref} __css={styles} {...props}>
        {children}
      </ChakraListItem>
    );
  }
);
export type { Props as ListItemProps };
